/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_NameInputs */

const vi_vehicle_name = /** @type {(inputs: Vehicle_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên xe`)
};

/**

* @param {Vehicle_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_name = /** @type {((inputs?: Vehicle_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_name(inputs)
});